
riot.tag2('news-categories-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.title}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="title" value="{item.title}">\n          <div class="help-block">{error.title}</div>\n        </div>\n        <div class="form-group {has-error: error.ident}">\n          <label class="control-label">Код</label>\n          <input class="form-control" name="ident" value="{item.ident}">\n          <div class="help-block">{error.ident}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = {};
    modal.mixin('validation');
    modal.mixin('change');

    modal.rules = {
        title: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };

    if (opts.id) {
        modal.loader = true;

        API.request({
            object: 'NewsCategory',
            method: 'Info',
            data: { id: opts.id },
            success: function success(response) {
                modal.item = response;
            },
            complete: function complete() {
                modal.loader = false;
                modal.update();
            }
        });
    }
});
});


// WEBPACK FOOTER //
// ./pages/news/news-categories-edit-modal.tag